<div class="flex items-center">
  <button
    pButton
    type="button"
    (click)="menu.toggle($event)"
    text
    size="small"
    severity="secondary"
  >
    <i pButtonIcon class="{{ PrimeIcons.WAREHOUSE }} text-surface-400"></i>
    <span
      pButtonLabel
      class="max-w-40 overflow-x-hidden whitespace-nowrap overflow-ellipsis"
      >{{ selectedWorkspace()?.name ?? 'Select a workspace' }}</span
    >
    <i pButtonIcon class="{{ PrimeIcons.ANGLE_DOWN }}"></i>
  </button>
  <p-menu #menu [model]="allWorkspacesByTeam()" [popup]="true">
    <ng-template #submenuheader let-item>
      <span class="text-sm">{{ item.label }}</span>
    </ng-template>
    <ng-template #end>
      <div class="flex flex-col p-1 border-t border-surface-200">
        <a
          pButton
          [routerLink]="['/', 'admin', 'workspaces', 'create']"
          class="w-full"
          severity="secondary"
          text
        >
          <i pButtonIcon class="{{ PrimeIcons.PLUS }}"></i>
          <span pButtonLabel class="grow">New Workspace</span>
        </a>
        <a
          pButton
          [routerLink]="['/', 'admin', 'workspaces']"
          class="w-full"
          severity="secondary"
          text
        >
          <i pButtonIcon class="{{ PrimeIcons.COG }}"></i>
          <span pButtonLabel class="grow">Manage Workspaces</span>
        </a>
      </div>
    </ng-template>
  </p-menu>
</div>
